export default __webpack_public_path__ + "static/media/boarding-asociaciones.90727c78.svg";